
<template>
    <div>
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">

        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <base-dropdown>
                               <base-button slot="title" type="danger" class="dropdown-toggle">
                                 POS Readings - {{_.startCase(currentProfile)}}
                               </base-button> 
                               <a @click.prevent="changeFilter('z_readings')" class="dropdown-item" href="#">Z Reading</a>
                               <a @click.prevent="changeFilter('x_readings')" class="dropdown-item" href="#">X Reading</a>
                               <!-- <a @click.prevent="changeFilter(_.pluralize(_.snakeCase(profile.name)))" class="dropdown-item" href="#">X Reading</a> -->
                            </base-dropdown>
                        </div>
                        
                        <div class="row no-gutters">
                            <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                              <div class="card-body">
                                    <div class="filter-bar ui basic segment grid">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <base-input label="Business Date"><br>
                                                    <a-range-picker v-model="filterText.business_date" format="MM/DD/YYYY" :placeholder="['Start Date', 'End Date']" style="width:100%" @change="doFilter" />
                                                </base-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <base-input label="Site"><br>
                                                    <a-select v-model="filterText.site_id" showSearch placeholder="Search by site" @change="filterTerminal" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <base-input label="Terminal"><br>
                                                    <a-select v-model="filterText.terminal_id" showSearch placeholder="Search by terminal" @change="doFilter" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                        <a-select-option v-for="option in terminalOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                                    </a-select>
                                                </base-input>
                                            </div>
                                        </div>
                                    </div>
                              </div>
                            </div>
                            <div class="col-md-9" id="profileDiv">
                                <div v-if="currentProfile == 'z_readings'">
                                    <z-table :key="formKey"></z-table>
                                </div>
                                <div v-else>
                                    <x-table :key="formKey"></x-table>
                                </div>
                                <!-- <profiles-table :key="formKey"></profiles-table> -->
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import XTable from '../Tables/XReadingTable.vue' 
  import ZTable from '../Tables/ZReadingTable.vue' 
  import secureStorage from '../../controllers/secureStorage.js'
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment';
  var component_x;

  export default {
      data: function(){
          return {
              formKey: 0,
              activeModules: [],
              filterText: {
                terminal_id: 0,
                site_id: 0,
                business_date: [moment().startOf('day'), moment().endOf('day')]
              },
              dateFormat: "MM/DD/YYYY",
              terminalOptions: [],
              siteOptions: []
          }
      },
      mounted: async function() {
        // component_x = this;
        // alert("LOADED!!")
        var siteId = secureStorage.getItem("defaultSiteId")
        var userId = secureStorage.getItem("userId")
        var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
        this.siteOptions = sites;
        this.sort(this.siteOptions);
        this.filterText.site_id = siteId

        var terminals = await HTTPRequest.getRequest(this.endPoint + "terminals/get_valid_terminals?site_id=" + siteId, null);
        this.terminalOptions = terminals;
        this.terminalOptions.push({id: 0, name: ' All Terminals'})
        this.sort(this.terminalOptions);

        this.setCurrentProfile("z_readings");
        this.doFilter();

      },
      computed: {
        ...mapState(['currentProfile','currentApiURL', 'endPoint']),
      },
      components:{
          XTable,
          ZTable
      },
      methods:{
        ...mapActions(['updateCurrentProfile', 'updateParameters']),
        changeFilter(profile){
            console.log(profile)
            this.setCurrentProfile(profile)
            this.formKey++
        },
        setCurrentProfile(profile){
            this.updateCurrentProfile(profile)
            // eslint-disable-next-line 
            //this.$children[2].$refs.vuetable.refresh()
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        filterTerminal: async function(){
            component_x = this
            let terminals = await HTTPRequest.getRequest(component_x.endPoint + "terminals/get_valid_terminals?site_id=" + component_x.filterText.site_id, null);
            component_x.terminalOptions = terminals;
            component_x.terminalOptions.push({id: 0, name: ' All Terminals'})
            component_x.sort(component_x.terminalOptions);

            component_x.filterText.terminal_id = 0

            this.doFilter()
        },
        sort(data){
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        doFilter(){
            console.log("---- filter")
            let add_business_date = ""
            if (this.filterText.business_date != null && this.filterText.business_date.length != 0){
                add_business_date = "from_date=" + this.filterText.business_date[0].format('YYYY-MM-DD') + "&to_date=" + this.filterText.business_date[1].format('YYYY-MM-DD')
            }

            let add_terminal = ""
            if(this.filterText.terminal_id != 0){
                add_terminal = "&terminal_id=" + this.filterText.terminal_id
            }

            let add_site = "&site_id=" + this.filterText.site_id

            this.updateParameters("?" +  add_business_date + add_site + add_terminal)
        }
      }
  };
</script>

<style>

</style>
